
import Vue from 'vue';
import Icon from '@root/modules/weather/components/Icon.vue';
import { weatherIconParser, windDirection } from '@root/modules/weather/utils/weatherParser';

interface Data {
  activeDay: string | null;
}

interface Props {
  forecastData: Record<string, any>;
}

interface Methods {
  weatherIconParser: typeof weatherIconParser;
  windDirection: typeof windDirection;
}

interface Computed {
  locale: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Icon,
  },
  props: {
    forecastData: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      activeDay: null,
      type: null,
    };
  },
  methods: {
    weatherIconParser,
    windDirection,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');
      return locale.split('_')[0];
    },
  },
});
